/**
 * Редиректы старых адресов каталога (`/catalog`, `/product/:uid`) в разделы ЛК (Э7-1, этап 07).
 * Старые экраны (`CatalogListComponent`, `ProductModule`) из роутинга убраны: техника живёт только в
 * `/cabinet/equipment`, запчасти — в `/cabinet/parts`. Чистые функции, покрыты node-спекой.
 */

/** Параметры нового раздела, собранные из query старого `/catalog`. */
export interface CatalogRedirectQuery {
  category?: number;
  keyword?: string;
  page?: number;
}

/** Куда переносится старый `/catalog`. */
export const PARTS_CATALOG_PATH = '/cabinet/parts';

/** Раздел карточки техники и запчасти. */
export const EQUIPMENT_CATALOG_PATH = '/cabinet/equipment';

type QueryValue = string | string[] | null | undefined;

/**
 * `/catalog?catalog_id=&keyword=&page=&region=&hasStock=&…` → `?category=&keyword=&page=`.
 * Переносятся только раздел, поиск и страница (> 1); `region`, `hasStock` и фильтры характеристик
 * у нового каталога нет — отбрасываются. Мусор в числах — параметр не переносится.
 */
export function catalogRedirectQuery(params: Record<string, QueryValue> | null | undefined): CatalogRedirectQuery {
  const query: CatalogRedirectQuery = {};
  const category = positiveInt(first(params?.['catalog_id']));
  if (category) {
    query.category = category;
  }
  const keyword = (first(params?.['keyword']) ?? '').trim();
  if (keyword) {
    query.keyword = keyword;
  }
  const page = positiveInt(first(params?.['page']));
  if (page && page > 1) {
    query.page = page;
  }
  return query;
}

/**
 * Куда вести старую карточку `/product/:uid` по ответу `/product/{uid}`: техника — в карточку модели,
 * запчасть или бэк без признака (ещё не задеплоен) — в карточку запчасти.
 */
export function productRouteFor(uid: string, product: {isTechnique?: boolean | null} | null | undefined): string[] {
  return [product?.isTechnique ? EQUIPMENT_CATALOG_PATH : PARTS_CATALOG_PATH, uid];
}

function first(value: QueryValue): string | undefined {
  return Array.isArray(value) ? value[0] : value ?? undefined;
}

function positiveInt(value: string | undefined): number | null {
  const parsed = Number(value);
  return value && Number.isInteger(parsed) && parsed > 0 ? parsed : null;
}
